export default __webpack_public_path__ + "static/media/19-EXT-(3-2).c21bd8eb.jpg";